import { useRef } from 'react'
import { Calendar, Modal, PillButton } from '@collegebacker/backer-ui/ui'

import styles from './DatePicker.module.scss'
import moment from 'moment'

const DatePicker = ({
  title = 'Select date',
  activationDate,
  onChange
}: Props) => {
  const modalRef = useRef<any>(null)

  return (
    <>
      <PillButton
        label={moment(activationDate).format('MMMM D, YYYY')}
        icon='chevron-down'
        onClick={() => modalRef.current.open()}
      />
      <Modal
        ref={modalRef}
        isBottomSheet={true}
        style={
          {
            '--max-width': '430px',
            '--padding-side': '40px',
            '--padding-top': '40px',
            '--padding-top-mobile': '30px',
            '--padding-bottom': '40px'
          } as any
        }
        className={styles.content}
      >
        <h2 className='typo-app-title-small'>{title}</h2>
        <Calendar
          onChange={onChange}
          defaultValue={activationDate}
          minDate={new Date()}
          maxDate={addMonths(13)}
          onClickDay={() => {
            modalRef.current.close()
          }}
        />
      </Modal>
    </>
  )
}

export function addMonths(months: number) {
  const start = new Date()
  const end = new Date(start)
  end.setMonth(end.getMonth() + months)
  return end
}
export default DatePicker

interface Props {
  activationDate: Date
  onChange: (arg0: Date) => void
  title?: string
}
